import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Components/Home';
import NewEPR from './Components/NewEPR';
import Layout from './Components/Shared/Layout';
import Error from './Components/Error';
import Appointment from './Components/Appointment';
import About from './Components/About';

function App() {
 return (
  <BrowserRouter>
   <Layout>
    <Routes>
     <Route path='/' element={<Home />}>
      <Route path=':id' element={<Home />} />
     </Route>
     <Route path='/newEPR' exact element={<NewEPR />} />
     <Route path='/bookDemo' exact element={<Appointment />} />
     <Route path='/about' exact element={<About />} />
     <Route path='*' element={<Error />} />
    </Routes>
   </Layout>
  </BrowserRouter>
 );
}

export default App;
